"use client"
// import OrderManagement from "src/sections/account/order-management"
import { CancelButton } from "@src/components/Button"
import Icons from "@src/components/Icons"
import { ROUTES } from "@src/constants"
import useRouterClient from "@src/hooks/use-router-client"

const ButtonBack = ({
  label = "",
  url = ROUTES.PRODUCT
}) => {
  const { router } = useRouterClient()

  const handleRedirect = () => {
    router.push(url)
  }

  return (
    <CancelButton
      label={label}
      minHeight="40px"
      minWidth="120px"
      sx={{
        marginBottom: "24px",
        "& span": {
          fontSize: "1.2rem",
        },
        "& .MuiButton-icon": {
          width: "14px",
          height: "14px",
          paddingRight: "18px"
        }
      }}
      startIcon={<Icons name="arrow-left" />}
      onClick={handleRedirect}
    />
  )
}

export default ButtonBack
